import axios from 'axios';
import { Command, SessionEvent, SessionState, SessionSummary } from './types';

const BASE_URL = import.meta.env.VITE_API_ENDPOINT || 'https://smlr.reshci-c-uw2.cloudos.autodesk.com/api';

export const getLiveSessionState = async (seriesId: string): Promise<SessionState> => {
  const url = `${BASE_URL}/v2/series/${encodeURIComponent(seriesId)}/sessions/live/state`;
  const res = await axios.get<SessionState>(url);
  return res.data;
};

export const ensureSeriesSession = async (
  seriesId: string,
  name: string,
  defaultDuration: number
): Promise<SessionState> => {
  const url = `${BASE_URL}/v2/series/${encodeURIComponent(seriesId)}/ensure`;
  const res = await axios.post<SessionState>(url, { name, defaultDuration });
  return res.data;
};

export const getSessionStateById = async (seriesId: string, sessionId: string): Promise<SessionState> => {
  const url = `${BASE_URL}/v2/series/${encodeURIComponent(seriesId)}/sessions/${encodeURIComponent(sessionId)}/state`;
  const res = await axios.get<SessionState>(url);
  return res.data;
};

export const listSeriesSessions = async (seriesId: string): Promise<SessionSummary[]> => {
  const url = `${BASE_URL}/v2/series/${encodeURIComponent(seriesId)}/sessions`;
  const res = await axios.get<{ sessions: SessionSummary[] }>(url);
  return res.data.sessions ?? [];
};

export const postSessionCommands = async (params: {
  seriesId: string;
  sessionId: string;
  expectedRevision: number;
  actorId: string;
  commands: Command[];
}): Promise<SessionState> => {
  const url = `${BASE_URL}/v2/series/${encodeURIComponent(params.seriesId)}/commands`;
  const res = await axios.post<SessionState>(url, {
    sessionId: params.sessionId,
    expectedRevision: params.expectedRevision,
    actorId: params.actorId,
    commands: params.commands,
  });
  return res.data;
};

export const endSessionAndSave = async (params: {
  seriesId: string;
  sessionId: string;
  actorId: string;
}): Promise<SessionState> => {
  const url = `${BASE_URL}/v2/series/${encodeURIComponent(params.seriesId)}/sessions/end`;
  const res = await axios.post<SessionState>(url, {
    sessionId: params.sessionId,
    actorId: params.actorId,
  });
  return res.data;
};

export const getSessionEvents = async (seriesId: string, sessionId: string): Promise<SessionEvent[]> => {
  const url = `${BASE_URL}/v2/series/${encodeURIComponent(seriesId)}/sessions/${encodeURIComponent(sessionId)}/events`;
  const res = await axios.get<{ events: SessionEvent[] }>(url);
  return res.data.events ?? [];
};

export const getSessionReplayExport = async (seriesId: string, sessionId: string): Promise<unknown> => {
  const url = `${BASE_URL}/v2/series/${encodeURIComponent(seriesId)}/sessions/${encodeURIComponent(sessionId)}/replay`;
  const res = await axios.get(url);
  return res.data;
};
